var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('reminder-calendar',{attrs:{"reminders":_vm.reminders,"show-add-reminder":false},on:{"get-reminders":_vm.getReminders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }